import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { Observable } from "rxjs";
@Injectable({
  providedIn: "root",
})
export class AdminGuard {
  constructor(public router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    // Guard for user is login or not
    let user = JSON.parse(localStorage.getItem("currentUser"));
    if( localStorage.getItem("currentUser") == undefined) {
      localStorage.removeItem("currentUser");
      localStorage.removeItem("token");
      this.router.navigate(["/auth/login"]);
    } else {
    if (!user || user === null) {
      this.router.navigate(["/auth/login"]);
    } else if (user) {
      if (!Object.keys(user).length) {
        this.router.navigate(["/auth/login"]);
      }
    }
  }
    return true;
  }
}